
import router from '../../router';
<template>
    <div class="link-inicio">
        <router-link :to="{name: 'ConfirmarIdentidade'}">Ir para o início</router-link>
    </div>
</template>

<script>
export default{
    name: "LinkInicio",
};
</script>

<style scoped>
.link-inicio{
    margin: 20px;
    text-align: center;
}

.link-inicio a{
    text-decoration: none;
    font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/LinkInicio.vue